/**
 * @file index.tsx
 *
 * @fileoverview Renders a component.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { JobCartMetaData } from '~/jobiqo/components/Job/Wizard/components/JobCartMetaData';
import { CommerceOrder, Job } from '~/jobiqo/types/types';
import { JobWizardFlow } from '~/jobiqo/components/Job/Wizard/config';
import { CartOrderInfo } from '~/jobiqo/components/Cart/components/CartOrderInfo';
import { Box } from '~/vcl/atoms/07-box';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { Hr } from '~/vcl/atoms/06-layout/10-hr';
interface JobCartProps {
  /**
   * The commerce order
   */
  order?: CommerceOrder;
  /**
   * The message to display (e.g. if credits are used)
   */
  message?: string;
  /**
   * The current job wizard flow (e.g. republish or adding upgrades).
   *
   * @default JobWizardFlow.New
   */
  flow?: JobWizardFlow;
  /**
   * The job if the cart is for a specific job (republish or upgrades).
   */
  job?: Job;
}

export const JobCart = ({
  order,
  message,
  flow = JobWizardFlow.New,
  job,
}: JobCartProps) => {
  return (
    <Box marginTop={0}>
      <Text data-test-id="job-cart-title" margin={0} fontWeight="bold">
        <FormattedMessage id="cart_title" defaultMessage="Cart summary" />
      </Text>
      <Spacing size="large" />
      <>
        {!order && message && (
          <>
            <FlexItems justifyContent="space-between">
              <FlexItem>
                <Text margin={0} color="gray9">
                  {message}
                </Text>
              </FlexItem>
            </FlexItems>
            <Spacing size="medium">
              <Hr />
            </Spacing>
          </>
        )}
        {order ? (
          <>
            {message && (
              <>
                <FlexItems justifyContent="space-between">
                  <FlexItem>
                    <Text margin={0} color="gray9">
                      {message}
                    </Text>
                  </FlexItem>
                </FlexItems>
                <Spacing size="medium">
                  <Hr />
                </Spacing>
              </>
            )}
            <CartOrderInfo order={order} />
          </>
        ) : (
          <>
            {!message && !order ? (
              <JobCartMetaData job={job} flow={flow} />
            ) : null}
          </>
        )}
      </>
      <Spacing size="medium" />
      <Text color="gray4" fontSize={2}>
        <FormattedMessage
          id="order_vat_info"
          defaultMessage="The total amount includes VAT, an invoice will be sent by email."
        />
      </Text>
    </Box>
  );
};
